export default {
  serverUrl: "https://server.sync.hamoni.tech/"
};
